// reducers.js
import {
    FETCH_BANNER, FETCH_COLOR_LIST,
    FETCH_DRAWER_MENU,
    FETCH_LATEST_VERSION,
    FETCH_PRODUCT_LIST, FETCH_SPACE_LIST,
    SET_BANNER, SET_COLOR_LIST,
    SET_DRAWER_MENU, SET_PRODUCT_LIST, SET_SPACE_LIST
} from '../actions';
import {SET_LATEST_VERSION} from "../actions";
// import {SET_LATEST_VERSION} from "./actionTypes";

const initialState = {
    spaceData: null,
    isLoading: false,
    error: null,
};

const spaceListReducer = (state = initialState, action) => {


    switch (action.type) {

        // case SET_LOADING:
        //     return {
        //         ...state,
        //         isLoading: action.payload,
        //     };
        //
        // case SET_ERROR:
        //     return {
        //         ...state,
        //         error: action.payload,
        //     };

        case FETCH_SPACE_LIST:
            return {
                ...state,
            };

        case SET_SPACE_LIST:
            return {
                ...state,
                spaceData: action.payload,
                isLoading: false,
            };

        default:
            return state;
    }
};

export default spaceListReducer;
